var _path, _g, _circle, _path2, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgActivity(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 50,
    height: 51,
    viewBox: "0 0 50 51",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10.6416 32.8918H10V36.9997H14.4188V36.3703H10.6416V32.8918ZM39.428 32.8918V36.3703H35.6509V36.9997H40.0696V32.8918H39.428ZM10.0003 14.9461H10.6419V11.4682H14.4191V10.8389H10.0003V14.9461ZM35.6509 10.8389V11.4683H39.428V14.9461H40.0696V10.8389H35.6509Z",
    fill: "#E6E6FF"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_875_4915)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 12.9673,
    y: 12.5645,
    width: 24.393,
    height: 21.9841,
    rx: 1,
    fill: "#FFFFFE"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 24.1001,
    y: 14.6182,
    width: 2.25166,
    height: 2.73851,
    rx: 1,
    fill: "#E6E6FF"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 24.1001,
    y: 18.498,
    width: 2.25166,
    height: 2.73851,
    rx: 1,
    fill: "#E6E6FF"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 24.1001,
    y: 22.377,
    width: 2.25166,
    height: 2.73851,
    rx: 1,
    fill: "#E6E6FF"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 24.1001,
    y: 26.2568,
    width: 2.25166,
    height: 2.73851,
    rx: 1,
    fill: "#E6E6FF"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 24.1001,
    y: 30.1367,
    width: 2.25166,
    height: 2.73851,
    rx: 1,
    fill: "#E6E6FF"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 14.7183,
    y: 22.377,
    width: 2.25166,
    height: 2.73851,
    rx: 1,
    fill: "#E6E6FF"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 14.7183,
    y: 26.2568,
    width: 2.25166,
    height: 2.73851,
    rx: 1,
    fill: "#E6E6FF"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 14.7183,
    y: 30.1367,
    width: 2.25166,
    height: 2.73851,
    rx: 1,
    fill: "#E6E6FF"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 30.355,
    y: 14.6182,
    width: 2.25166,
    height: 2.73851,
    rx: 1,
    fill: "#E6E6FF"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 30.355,
    y: 18.498,
    width: 2.25166,
    height: 2.73851,
    rx: 1,
    fill: "#E6E6FF"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 20.9731,
    y: 18.498,
    width: 2.25166,
    height: 2.73851,
    rx: 1,
    fill: "#E6E6FF"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 20.9731,
    y: 14.6182,
    width: 2.25166,
    height: 2.73851,
    rx: 1,
    fill: "#E6E6FF"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 20.9731,
    y: 22.377,
    width: 2.25166,
    height: 2.73851,
    rx: 1,
    fill: "#E6E6FF"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 20.9731,
    y: 26.2568,
    width: 2.25166,
    height: 2.73851,
    rx: 1,
    fill: "#E6E6FF"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 20.9731,
    y: 30.1367,
    width: 2.25166,
    height: 2.73851,
    rx: 1,
    fill: "#E6E6FF"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 27.228,
    y: 14.6182,
    width: 2.25166,
    height: 2.73851,
    rx: 1,
    fill: "#E6E6FF"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 27.228,
    y: 18.498,
    width: 2.25166,
    height: 2.73851,
    rx: 1,
    fill: "#E6E6FF"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 17.8457,
    y: 22.377,
    width: 2.25166,
    height: 2.73851,
    rx: 1,
    fill: "#E6E6FF"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 17.8457,
    y: 26.2568,
    width: 2.25166,
    height: 2.73851,
    rx: 1,
    fill: "#E6E6FF"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 17.8457,
    y: 30.1367,
    width: 2.25166,
    height: 2.73851,
    rx: 1,
    fill: "#E6E6FF"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 33.4824,
    y: 14.6182,
    width: 2.25166,
    height: 2.73851,
    rx: 1,
    fill: "#E6E6FF"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 33.4824,
    y: 18.498,
    width: 2.25166,
    height: 2.73851,
    rx: 1,
    fill: "#E6E6FF"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 30.355,
    y: 22.3799,
    width: 2.25166,
    height: 2.73851,
    rx: 1,
    fill: "#E6E6FF"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 30.355,
    y: 26.3799,
    width: 2.25166,
    height: 2.73851,
    rx: 1,
    fill: "#E6E6FF"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 27.228,
    y: 22.3799,
    width: 2.25166,
    height: 2.73851,
    rx: 1,
    fill: "#E6E6FF"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 27.228,
    y: 26.3799,
    width: 2.25166,
    height: 2.73851,
    rx: 1,
    fill: "#E6E6FF"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 33.4824,
    y: 22.3799,
    width: 2.25166,
    height: 2.73851,
    rx: 1,
    fill: "#E6E6FF"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 33.4824,
    y: 26.3799,
    width: 2.25166,
    height: 2.73851,
    rx: 1,
    fill: "#E6E6FF"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 12.9673,
    y: 8,
    width: 24.393,
    height: 4.56418,
    rx: 1,
    fill: "#E6E6FF"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 16.8019,
    cy: 9.93608,
    rx: 0.884944,
    ry: 0.829635,
    fill: "#951CE4"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 33.9108,
    cy: 9.93608,
    rx: 0.884944,
    ry: 0.829635,
    fill: "#951CE4"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 17.1647,
    cy: 18.1051,
    r: 3.24479,
    fill: "#E6E6FF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.8922 19.5332L15.7418 18.5047C15.6727 18.443 15.6727 18.3428 15.7418 18.281L15.9921 18.0572C16.0612 17.9954 16.1733 17.9954 16.2424 18.0572L17.0174 18.75L18.6773 17.2661C18.7464 17.2043 18.8585 17.2043 18.9276 17.2661L19.1779 17.4898C19.247 17.5516 19.247 17.6518 19.1779 17.7136L17.1425 19.5332C17.0734 19.595 16.9613 19.595 16.8922 19.5332Z",
    fill: "#951CE4"
  }))), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 36.5,
    cy: 32.5,
    r: 6.5,
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M36.5 26C32.9093 26 30 28.9093 30 32.5C30 36.0907 32.9093 39 36.5 39C40.0907 39 43 36.0907 43 32.5C43 28.9093 40.0907 26 36.5 26ZM40.2742 33.2339C40.2742 33.4069 40.1327 33.5484 39.9597 33.5484H37.5484V35.9597C37.5484 36.1327 37.4069 36.2742 37.2339 36.2742H35.7661C35.5931 36.2742 35.4516 36.1327 35.4516 35.9597V33.5484H33.0403C32.8673 33.5484 32.7258 33.4069 32.7258 33.2339V31.7661C32.7258 31.5931 32.8673 31.4516 33.0403 31.4516H35.4516V29.0403C35.4516 28.8673 35.5931 28.7258 35.7661 28.7258H37.2339C37.4069 28.7258 37.5484 28.8673 37.5484 29.0403V31.4516H39.9597C40.1327 31.4516 40.2742 31.5931 40.2742 31.7661V33.2339Z",
    fill: "#951CE4"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_875_4915",
    x: 0.967285,
    y: 0,
    width: 48.3931,
    height: 50.5488,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 4
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 6
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.06 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_875_4915"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_875_4915",
    result: "shape"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgActivity);
export default __webpack_public_path__ + "static/media/activity.de1185e7f1645ff3cc87ed1f1bdd6322.svg";
export { ForwardRef as ReactComponent };